
















































































import { Vue, Component } from "vue-property-decorator";
import DocumentSvg from "@/components/svg/DocumentsSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import { namespace } from "vuex-class";
import { DocumentPayload, DocumentType } from "../types";
import axios from "axios";

const Document = namespace("document");

@Component({
  components: {
    "document-svg": DocumentSvg,
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class ChooseDocument extends Vue {
  @Document.Action("updateDocumentType") updateDocumentType!: (
    payload: DocumentPayload
  ) => void;
  @Document.Getter("isPassportSupported") isPassportSupported!: boolean;
  @Document.Getter("isNationalIdSupported") isNationalIdSupported!: boolean;
  @Document.Getter("isDriversLicenseSupported")
  isDriversLicenseSupported!: boolean;
  @Document.Getter("getCountry") country!: string;
  isSelected = false;
  selectedDocument = "";

  chooseDocument() {
    switch (this.selectedDocument) {
      case "license":
        this.clickSelectDocumentType(6);
        this.$router.push({
          name: "catureLicenseFront",
          query: this.$route.query,
        });
        break;
      case "passport":
        this.clickSelectDocumentType(8);
        if (this.country === "Jamaica") {
          this.$router.push({ name: "captureTrn", query: this.$route.query });
        } else {
          this.$router.push({
            name: "capturePassport",
            query: this.$route.query,
          });
        }
        break;
      case "national":
        this.clickSelectDocumentType(9);
        if (this.country === "Jamaica") {
          this.$router.push({ name: "captureTrn", query: this.$route.query });
        } else {
          this.$router.push({
            name: "captureNationalFront",
            query: this.$route.query,
          });
        }
        break;
    }
  }
  clickSelectDocumentType(progressionStep) {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
  setSelectedDocument(event) {
    this.selectedDocument = event.target.value;

    switch (this.selectedDocument) {
      case "license":
        this.updateDocumentType({ documentType: DocumentType.DRIVERSLICENSE });
        break;
      case "passport":
        this.updateDocumentType({ documentType: DocumentType.PASSPORT });
        break;
      case "national":
        this.updateDocumentType({ documentType: DocumentType.NATIONALID });
        break;
    }
    this.isSelected = true;
  }

  async mounted() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopChooseCountry();
    }
    if (Vue.prototype.$useAudioInstructions) {
      await Vue.prototype.$audioConfigs.playChooseDocument();
    }
  }

  beforeUnmount() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopChooseDocument();
    }
  }
}
